/**
 * @link https://mui.com/material-ui/react-paper/
 */

import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureePaper() {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          '& > :not(style)': {
            m: 1,
            width: 128,
            height: 128,
          },
        }}
      >
        <Paper />
        <Paper elevation={2} />
        <Paper elevation={3} />
      </Box>
      
      <ShowCode 
        codeString={`function PaperExample() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          width: 128,
          height: 128,
        },
      }}
    >
      {/* Paper with default elevation (1) */}
      <Paper />
      
      {/* Paper with custom elevations */}
      <Paper elevation={2} />
      <Paper elevation={3} />
    </Box>
  );
}`} 
        scope={{ 
          React, 
          Box, 
          Paper 
        }} 
      />
    </>
  );
}